import React, { useState } from 'react';
import MagicForm from '../../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../../Enums/MagicField.enum';
import { WorkplaceAclRole } from '../../../../../Workplace/Enums/WorkplaceAclRole.enum';
import apiClient from '../../../../../../Services/ApiClient';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import { useManagerContext } from '../../../../Services/ManagerContext';
import Loading from '../../../../../../Components/Loading';

const FORM_SCHEME: ItemScheme[] = [
	{
		type: MagicField.EMAIL,
		key: 'email',
		title: 'component.workplaceAndWorkers.enterWorkersEmail',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.PHONE_NUMBER,
		key: 'phoneNumber',
		title: 'component.workplaceAndWorkers.enterWorkersPhone',
	},
	{
		type: MagicField.MULTIPLIER,
		key: 'workplaces',
		children: [
			{
				type: MagicField.HSTACK,
				children: [
					{
						type: MagicField.WORKPLACE_SELECT,
						key: 'workplace',
						title: 'base.chooseWorkplace',
						settings: {
							required: true,
							portal: true,
						},
					},
					{
						type: MagicField.ROLE_MULTISELECT_WITH_CHECKLIST,
						key: 'role',
						title: 'base.chooseWorkerRole',
						settings: {
							required: true,
							excludeRoleKeys: [WorkplaceAclRole.ADMIN],
						},
					},
				],
			},
			{
				type: MagicField.MULTIPLIER_REMOVE_BUTTON,
			},
		],
		settings: {
			createDefault: 1,
			addButtonTitle: 'base.addWorkerToWorkplace',
			min: 1,
		},
	},
];

interface Role {
	value: string;
	label: string;
}

interface Workplace {
	workplace: {
		value: string;
		label: string;
	};
	role: Role[];
}

interface WorkplaceMembers {
	workplaceId: string;
	roleId: string[];
}

interface Props {
	onCreate: () => void;
}

const ManagerAddWorkerByInvitation: React.FC<Props> = ({ onCreate }) => {
	const { displayError } = useApiClient();
	const { rootWorkplaceId } = useManagerContext();
	const [isLoading, setIsLoading] = useState(false);

	function transformWorkplaces(input: Workplace[]): WorkplaceMembers[] {
		return input.map(({ workplace, role }) => ({
			workplaceId: workplace.value,
			roleId: role.map(r => r.value),
		}));
	}

	const handleSubmit = async (values: any) => {
		setIsLoading(true);
		if (rootWorkplaceId) {
			const { workplaces, ...restOfValues } = values;
			try {
				const response = await apiClient.post(
					`/workplaces/${rootWorkplaceId}/members/invitation`,
					{
						...restOfValues,
						workplaceMembers: transformWorkplaces(workplaces),
					},
				);
				console.log('response', response);
				if (response.status === 200) {
					onCreate();
				}
			} catch (e) {
				displayError(e);
			}
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<MagicForm
			formScheme={FORM_SCHEME}
			onSubmit={handleSubmit}
			submitText='component.userHasUserShare.sendInvite'
		/>
	);
};

export default ManagerAddWorkerByInvitation;
